import { render } from "./Mailer.vue?vue&type=template&id=1c209c17&scoped=true"
import script from "./Mailer.vue?vue&type=script&lang=js"
export * from "./Mailer.vue?vue&type=script&lang=js"

import "./Mailer.vue?vue&type=style&index=0&id=1c209c17&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/rethinkrobotics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c209c17"]])

export default __exports__